import { useState } from 'react';
import { supabase } from '../lib/supabase';

export default function Auth() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    if (isSignUp) {
      const { error } = await supabase.auth.signUp({ email, password });
      if (error) {
        // Database trigger blocks unapproved emails
        if (error.message.includes('restricted') || error.message.includes('check_allowed_email') || error.status === 500) {
          setError('Signups are restricted to approved emails only. Contact the administrator for access.');
        } else {
          setError(error.message);
        }
      }
      else setMessage('Check your email to confirm your account, then sign in.');
    } else {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) setError(error.message);
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh', background: '#f7f5f2', display: 'flex',
      alignItems: 'center', justifyContent: 'center', fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif"
    }}>
      <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&family=DM+Sans:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&family=Space+Mono:wght@400;700&display=swap" rel="stylesheet" />
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        input { font-family: inherit; }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>

      <div style={{
        animation: 'fadeIn 0.4s ease-out',
        background: '#fefdfb', border: '1px solid rgba(0,0,0,0.08)', borderRadius: 16,
        padding: 40, width: '100%', maxWidth: 400
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h1 style={{ color: '#1a1a1a', fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 28, fontWeight: 300, letterSpacing: '-0.02em' }}>Sole Trader <em style={{ fontStyle: 'italic', color: '#c8956c' }}>Books</em></h1>
          <p style={{ color: '#8a8580', fontSize: 12, marginTop: 8, fontFamily: "'Space Mono', monospace", letterSpacing: '0.1em', textTransform: 'uppercase' }}>
            {isSignUp ? 'Create your account' : 'Sign in to your account'}
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 12, color: '#8a8580', marginBottom: 6, display: 'block' }}>Email</label>
            <input
              type="email" required value={email}
              onChange={e => setEmail(e.target.value)}
              style={{
                width: '100%', padding: '12px 14px', background: '#f0ece6',
                border: '1px solid rgba(0,0,0,0.08)', borderRadius: 8, color: '#1a1a1a',
                fontSize: 14, outline: 'none'
              }}
              onFocus={e => e.target.style.borderColor = '#c8956c'}
              onBlur={e => e.target.style.borderColor = 'rgba(0,0,0,0.08)'}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ fontSize: 12, color: '#8a8580', marginBottom: 6, display: 'block' }}>Password</label>
            <input
              type="password" required value={password}
              onChange={e => setPassword(e.target.value)}
              minLength={6}
              style={{
                width: '100%', padding: '12px 14px', background: '#f0ece6',
                border: '1px solid rgba(0,0,0,0.08)', borderRadius: 8, color: '#1a1a1a',
                fontSize: 14, outline: 'none'
              }}
              onFocus={e => e.target.style.borderColor = '#c8956c'}
              onBlur={e => e.target.style.borderColor = 'rgba(0,0,0,0.08)'}
            />
          </div>

          {error && (
            <div style={{
              background: 'rgba(200,92,92,0.1)', color: '#c85c5c', padding: '10px 14px',
              borderRadius: 8, fontSize: 13, marginBottom: 16
            }}>{error}</div>
          )}

          {message && (
            <div style={{
              background: 'rgba(74,124,138,0.1)', color: '#4a7c8a', padding: '10px 14px',
              borderRadius: 8, fontSize: 13, marginBottom: 16
            }}>{message}</div>
          )}

          <button
            type="submit" disabled={loading}
            style={{
              width: '100%', padding: '12px', background: '#1a1a1a', color: '#f0ece6',
              border: 'none', borderRadius: 50, fontWeight: 500, fontSize: 13,
              cursor: loading ? 'wait' : 'pointer', opacity: loading ? 0.7 : 1,
              fontFamily: 'inherit', letterSpacing: '0.03em', transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)'
            }}
          >
            {loading ? 'Please wait...' : isSignUp ? 'Create Account' : 'Sign In'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <button
            onClick={() => { setIsSignUp(!isSignUp); setError(''); setMessage(''); }}
            style={{
              background: 'none', border: 'none', color: '#c8956c',
              cursor: 'pointer', fontSize: 13, fontFamily: 'inherit'
            }}
          >
            {isSignUp ? 'Already have an account? Sign in' : "Don't have an account? Sign up"}
          </button>
        </div>
      </div>
    </div>
  );
}
